import { IconProps } from '../../atoms/Icon';
import { IndicatorProps } from '../../atoms/Indicator';
import { TextProps } from '../../atoms/Text';

type VerticalTabItemInternalProps = {
  icon?: IconProps;
  text?: TextProps;
  indicator?: IndicatorProps;
};

type VerticalTabItemPropsValues = {
  'Selected': VerticalTabItemInternalProps;
  'Unselected': VerticalTabItemInternalProps;
};

const propValues: VerticalTabItemPropsValues = {
  'Selected': {
    icon: {
      asset: 'Plus',
      colour: 'IconPrimary',
    },
    text: {
      align: 'Left',
      styleType: 'SemiBold',
      colour: 'Interactive',
      type: 'Heading6',
    },
    indicator: {
      state: 'Selected',
      type: 'Vertical',
      error: 'None',
    },
  },
  'Unselected': {
    icon: {
      asset: 'Plus',
      colour: 'IconDark',
    },
    text: {
      align: 'Left',
      styleType: 'Medium',
      colour: 'Dark',
      type: 'Heading6',
    },
  },
};

const getProps = (type: string): VerticalTabItemInternalProps => {
  const values: VerticalTabItemInternalProps = propValues[type];
  if (!values) {
    console.error(`${type} props not found`);
    return {};
  }
  return values;
};

export default getProps;
